export default __webpack_public_path__ + "static/token_holder_tablet-ae43157d3b04bc38e02843f0b352a2d4.png";